export default "__VITE_ASSET__D$pnn5rK__"